import { TREATMENT_PLAN_NAME_MAX_LENGTH } from '../constants/treatmentPlanConstants';

// The one place that decides whether a typed name may become a plan's name.
// The field and the year-plan edit both ask this, so the rule cannot drift
// between what the save button allows and what the hook is willing to write.
export function normalizeTreatmentPlanName(rawName: string): string | null {
  const trimmedName = rawName.trim();
  if (!trimmedName || trimmedName.length > TREATMENT_PLAN_NAME_MAX_LENGTH) return null;
  return trimmedName;
}
